var map = {
	"./ttt-cn.png": "hAWO",
	"./ttt-en.png": "R7J1",
	"./ttt-th.png": "dYsH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VSxQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title ^\.\/ttt\-.*\.png$
// module id = VSxQ
// module chunks = 1